import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconNightClearSky: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M75.5372 69.3114C75.0743 69.3286 74.62 69.38 74.1572 69.38C57.3657 69.38 43.6943 55.7171 43.6943 38.9171C43.6943 31.5886 46.3 24.8686 50.62 19.6057C52.2743 17.5914 54.2029 15.8171 56.3114 14.2829C54.8972 14.1114 53.4572 14 51.9914 14C50.6372 14 49.3086 14.0857 47.9972 14.2314C30.0057 16.2286 16 31.4686 16 50C16 69.8771 32.1229 86 52 86C62.3115 86 71.5857 81.6371 78.1515 74.6857C80.0543 72.6714 81.7257 70.4429 83.1229 68.0343C80.7143 68.78 78.1686 69.1914 75.5372 69.3114Z"
        fill="#D2D4DA"
      />
    </svg>
  )
}

export default WeatherIconNightClearSky
